import React, { useEffect, useState } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import ButtonWrapper from "../../../components/Button";
import { Col, Container, Row } from "react-bootstrap";
import SortingAlphabatically from "../../../reusableComponents/SortingAlphbatically";
import InputWrapper from "../../../layout/inputWrapper";
import FileUploader from "../../../reusableComponents/FileUploader2";
import ScrollButton from "../../../../../../../../core/src/pages/citizen/Home/AwasBandhu/UpwardScrollButton";
import { genderData, statesName } from "../../../../TCPForms/data";
import { shallowEqual, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { get, set } from "lodash";

const ownerEntry = {
  name: "",
  fatherOrHusbandName: "",
  mobileNumber: "",
  emailId: "",
  aadhaarNumber: "",
  gender: null,
  correspondenceAddress: {
    applicantName: null,
    applicantGuardianName: null,
    state: "",
    district: null,
    tehsil: null,
    town: null,
    address: "",
    pinno: "",
    type: "CORRESPONDENCE",
  },
  permanentAddress: {
    applicantName: null,
    applicantGuardianName: null,
    state: "",
    district: null,
    tehsil: null,
    town: null,
    address: "",
    pinno: "",
    type: "PERMANENT",
  },
};

const SubStep1 = ({
  formData,
  handleSubTabChange,
  applicationFlow,
  officesList,
  avpData,
  avpUnits,
  isEmployee,
  isApproved,
  id,
  setParams,
  initFormMTDocs,
  setShowToast,
}) => {
  const { documents } = useSelector((state) => state.formMT, shallowEqual);
  const [showError, setShowError] = useState(false);
  const [fastPASData, setFastPasData] = useState(null);
  const { t } = useTranslation();
  const defaultValues = {
    ...formData,

    department: applicationFlow,
    landInfo: {
      ...formData?.landInfo,
      owners: formData?.landInfo?.owners?.length > 0 ? formData?.landInfo?.owners : [ownerEntry],
    },
    documents: documents,
  };

  const { data: districtData, isLoading: isDistrictDataLoading } = Digit.Hooks.useTenants();
  // const updistricts = !isDistrictDataLoading && districtData.filter((district) => !district.code?.includes("up"));
  const updistricts = isDistrictDataLoading
    ? []
    : districtData.map((district) => ({
        label: district.name,
        value: district.name,
        name: district.name,
      }));
  console.log("upDIstricts", updistricts);

  const [loading, setLoading] = useState(false);
  const isDA = applicationFlow === "DA";
  const { handleSubmit, control, reset, watch, setValue, trigger, getValues } = useForm({ defaultValues });
  const { fields: owners, append: appendOwner, remove: removeOwner } = useFieldArray({
    control,
    name: "landInfo.owners",
  });
  const watchState = watch(`landInfo.owners.[0].correspondenceAddress.state`);
  const watchOffice = watch("selectedOffice") || formData?.selectedOffice;
  const watchSelectedOffice = isDA ? watchOffice?.split(" ")[0] : watchOffice?.split(",")[1]?.trim();
  const watchUnit = watch("selectedUnit") || formData?.selectedUnit;
  const watchCity = watch("selectedCity") || formData?.selectedCity;
  const filterCities = (unit, masterData) => {
    const result = masterData
      ?.filter((item) => item.Unit === unit)?.[0]
      ?.Cities?.map((item) => {
        return { name: item.City, label: item.City, value: item.City };
      });
    return result;
  };
  const avpCities = filterCities(watchUnit, avpData);

  const handleSearchClick = async (applicationNo) => {
    try {
      let response;
      let data;
      let purchasableData;
      const id = applicationNo.replace(/[-/]/g, "");
      if (applicationNo) {
        response = await Digit.OBPSService.BPAFastPASSearch({ land_Id: applicationNo });
        console.log(response, "responsefromId");
        if (response?.BPA?.length === 0) {
          setShowToast({
            key: "true",
            error: true,
            message: `No Data Found for this FASTPAS ID...!!`,
          });
          return;
        } else if (response?.BPA?.[0]?.department !== applicationFlow) {
          setShowToast({
            key: "true",
            error: true,
            message: `Please use the selected department FASTPASID`,
          });
          return;
        }
        data = response?.BPA?.filter((item) => item.applicationType === "FORM_LANDUSE")?.[0];
        Digit.SessionStorage.set("FASTPAS_CONVERSION", data);
        setFastPasData(data);
        const drawingPdfs = data?.documents?.filter((e) => e.documentType === "drawingPdf");
        // setDwgPdf(drawingPdfs?.[0]?.fileStoreId);
        if (data) {
          setShowToast({
            key: "true",
            error: false,
            message: `Data fetched Successfully...!!`,
          });
        }
        const architect = data?.additionalDetails?.professionalInformation;
        const descriptionOfLand = data?.descriptionOfLand;
        const documents = data?.documents;
        setValue("selectedOffice", data?.selectedOffice);
        setValue("landInfo.owners.[0].emailId", data?.landInfo?.owners?.[0]?.emailId);
        setValue("landInfo.owners.[0].mobileNumber", data?.landInfo?.owners?.[0]?.mobileNumber);
        setValue("landInfo.owners.[0].fatherOrHusbandName", data?.landInfo?.owners?.[0]?.fatherOrHusbandName);
        setValue("landInfo.owners.[0].gender", data?.landInfo?.owners?.[0]?.gender);
        setValue("landInfo.owners.[0].name", data?.landInfo?.owners?.[0]?.name);
        setValue("landInfo.owners.[0].correspondenceAddress.state", data?.landInfo?.owners?.[0]?.correspondenceAddress?.state);
        setValue("landInfo.owners.[0].correspondenceAddress.address", data?.landInfo?.owners?.[0]?.correspondenceAddress?.address);
        setValue("landInfo.owners.[0].correspondenceAddress.district", data?.landInfo?.owners?.[0]?.correspondenceAddress?.town);
        setValue("landInfo.owners.[0].aadhaarNumber", data?.landInfo?.owners?.[0]?.aadhaarNumber);
        setValue("landInfo.owners.[0].correspondenceAddress.pinno", data?.landInfo?.owners?.[0]?.correspondenceAddress?.pinno);

        setValue("professionalInformation.name", architect?.name);
        setValue("professionalInformation.planDate", architect?.planDate);
        setValue("professionalInformation.mobileNumber", architect?.mobileNumber);
        setValue("professionalInformation.emailId", architect?.emailId);
        setValue("professionalInformation.licenseNumber", architect?.licenseNumber);
        setValue("professionalInformation.consultantCategory", architect?.consultantCategory);

        // plot information:
        setValue("descriptionOfLand.landArea", descriptionOfLand?.landArea);
        setValue("descriptionOfLand.plotAreaDoc", descriptionOfLand?.plotAreaDoc);
        setValue("descriptionOfLand.developmentArea", descriptionOfLand?.developmentArea);
        setValue("descriptionOfLand.landUsesType", descriptionOfLand?.landUsesType);
        setValue("descriptionOfLand.subLandUseAsPerLayout", descriptionOfLand?.subLandUseAsPerLayout);
        setValue("descriptionOfLand.landMark", descriptionOfLand?.landMark);
        setValue("descriptionOfLand.activityAsPerMap", descriptionOfLand?.activityAsPerMap);
        setValue("descriptionOfLand.activityProposed", descriptionOfLand?.activityProposed);
        setValue("descriptionOfLand.landAddress", descriptionOfLand?.landAddress);
        setValue("descriptionOfLand.schemeType", descriptionOfLand?.schemeType);
        setValue("descriptionOfLand.planOn", descriptionOfLand?.planOn);
        setValue("descriptionOfLand.schemeName", descriptionOfLand?.schemeName);
        setValue("descriptionOfLand.longitude", descriptionOfLand?.longitude);
        setValue("descriptionOfLand.latitude", descriptionOfLand?.latitude);
        setValue("descriptionOfLand.khasraDetails", descriptionOfLand?.khasraDetails);
        setValue("descriptionOfLand.roadWidths", descriptionOfLand?.roadWidths);
        setValue("descriptionOfLand.approachRoadWidths", descriptionOfLand?.approachRoadWidths);

        setParams((prev) => ({
          ...prev,
          selectedOffice: data?.selectedOffice,
          landInfo: {
            ...prev.landInfo,
            owners: [
              {
                ...prev.landInfo?.owners?.[0],
                name: data?.landInfo?.owners?.[0]?.name,
                emailId: data?.landInfo?.owners?.[0]?.emailId,
                mobileNumber: data?.landInfo?.owners?.[0]?.mobileNumber,
                fatherOrHusbandName: data?.landInfo?.owners?.[0]?.fatherOrHusbandName,
                gender: data?.landInfo?.owners?.[0]?.gender,
                aadhaarNumber: data?.landInfo?.owners?.[0]?.aadhaarNumber,
                correspondenceAddress: {
                  ...prev.landInfo?.owners?.[0]?.correspondenceAddress,
                  state: data?.landInfo?.owners?.[0]?.correspondenceAddress?.state,
                  address: data?.landInfo?.owners?.[0]?.correspondenceAddress?.address,
                  district: data?.landInfo?.owners?.[0]?.correspondenceAddress?.town,
                  pinno: data?.landInfo?.owners?.[0]?.correspondenceAddress?.pinno,
                },
              },
            ],
          },
          professionalInformation: {
            ...prev.professionalInformation,
            name: architect?.name,
            planDate: architect?.planDate,
            mobileNumber: architect?.mobileNumber,
            emailId: architect?.emailId,
            licenseNumber: architect?.licenseNumber,
            consultantCategory: architect?.consultantCategory,
          },
          descriptionOfLand: {
            ...prev.descriptionOfLand,
            landArea: descriptionOfLand?.landArea,
            plotAreaDoc: descriptionOfLand?.plotAreaDoc,
            developmentArea: descriptionOfLand?.developmentArea,
            landUsesType: descriptionOfLand?.landUsesType,
            subLandUseAsPerLayout: descriptionOfLand?.subLandUseAsPerLayout,
            landMark: descriptionOfLand?.landMark,
            activityAsPerMap: descriptionOfLand?.activityAsPerMap,
            activityProposed: descriptionOfLand?.activityProposed,
            landAddress: descriptionOfLand?.landAddress,
            schemeType: descriptionOfLand?.schemeType,
            planOn: descriptionOfLand?.planOn,
            schemeName: descriptionOfLand?.schemeName,
            khasraDetails: descriptionOfLand?.khasraDetails,
            latitude: descriptionOfLand?.latitude,
            longitude: descriptionOfLand?.longitude,
          },
        }));
        initFormMTDocs([...documents]);
      }
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };

  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  useEffect(() => {
    setValue("landInfo.owners[0].correspondenceAddress.town", formData?.location1);
  }, [formData?.location1]);

  useEffect(() => {
    setLoading(true);
    const fetchBusinessService = async () => {
      if (isDA && watchSelectedOffice) {
        const location = watchSelectedOffice;
        const res = await Digit.LocationService.getBusinessServices(location, null, "FORM_LANDUSECONVERSION", applicationFlow);
        setValue("businessService", res);
        setLoading(false);
      } else if (watchUnit && watchCity) {
        const location2 = watchCity;
        const res = await Digit.LocationService.getBusinessServices(location2, null, "FORM_LANDUSECONVERSION", applicationFlow);
        setValue("businessService", res);
        setLoading(false);
      }
    };
    fetchBusinessService();
  }, [watchUnit, watchCity, watchSelectedOffice]);

  const validateFiles = () => {
    const uploadedDocs = documents?.map((doc) => doc.documentType);
    const isValid = ["signature"].every((doc) => uploadedDocs.includes(doc));
    return isValid;
  };

  const onSubmit = (data) => {
    const isValid = validateFiles();
    if (isValid) {
      data = {
        ...data,
        documents: documents,
        landInfo: {
          ...data.landInfo,
          tenantId: "up",
          address: {
            tenantId: "up",
            locality: {
              code: isDA ? watchSelectedOffice : watchCity,
            },
          },
        },
      };
      handleSubTabChange(1, data);
    } else {
      setShowError(true);
      return;
    }
  };

  return (
    <section className="groupContainer3">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">FASTPAS ID</h2>
          </div>
          <Container fluid className="formInputContainer common-app-form">
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label="FASTPAS Id"
                  placeholder="Enter FASTPAS Id"
                  name="land_Id"
                  type="textInput"
                  mandatory
                  defaultValue={formData?.land_Id}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={isEmployee}
                  showSearchIcon={true}
                  onSearchClick={() => handleSearchClick(getValues("land_Id"))}
                />
              </Col>
              <Col></Col>
            </Row>
          </Container>
          <div className="formHeaderContainer">
            <h2 className="formHeading">Verifying Authority</h2>
          </div>
          {isDA ? (
            <Container className="formInputContainer common-app-form" style={{ position: "relative", marginBottom: "10px" }} fluid>
              <Row>
                <Col>
                  <InputWrapper
                    width={"100%"}
                    control={control}
                    label={"Select Development Authority"}
                    inputLabel="Select office"
                    placeholder="Select office"
                    name="selectedOffice"
                    type={formData?.selectedOffice || isEmployee || isApproved ? "textInput" : "searchSelect"}
                    defaultValue={formData?.selectedOffice}
                    data={SortingAlphabatically(officesList)}
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    disabled={formData?.selectedOffice || isEmployee || isApproved || watch("selectedOffice")}
                  />
                </Col>
              </Row>
            </Container>
          ) : (
            <Container className="formInputContainer common-app-form" style={{ position: "relative", marginBottom: "10px" }} fluid>
              <Row>
                <Col>
                  <InputWrapper
                    control={control}
                    label={"Select Unit"}
                    inputLabel="Select unit"
                    placeholder="Select unit"
                    name="selectedUnit"
                    type="searchSelect"
                    data={SortingAlphabatically(avpUnits)}
                    defaultValue={formData?.selectedUnit || ""}
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    disabled={isEmployee || isApproved || watch("selectedUnit")}
                  />
                </Col>
                {watchUnit ? (
                  <Col>
                    <InputWrapper
                      control={control}
                      label={"Select City"}
                      inputLabel="Select city"
                      placeholder="Select city"
                      name="selectedCity"
                      type="searchSelect"
                      data={SortingAlphabatically(avpCities)}
                      defaultValue={formData?.selectedCity}
                      mandatory
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                      disabled={isEmployee || isApproved}
                    />
                  </Col>
                ) : (
                  <Col></Col>
                )}
              </Row>
            </Container>
          )}

          <div className="formHeaderContainer" style={{ marginTop: "26px" }}>
            <h2 className="formHeading">{t("Owner/Applicant Details")}</h2>
          </div>

          <Container className="formInputContainer common-app-form" fluid>
            <Row>
              <Col>
                <InputWrapper
                  width={"100%"}
                  label="Name"
                  control={control}
                  placeholder="Enter Name"
                  name={`landInfo.owners.[0].name`}
                  type="textInput"
                  maxLength={30}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("Name"),
                      message: "Please enter only letters and spaces",
                    },
                  }}
                  disabled={isEmployee || isApproved || watch("landInfo.owners.[0].name")}
                />
              </Col>
              <Col>
                <InputWrapper
                  width={"100%"}
                  control={control}
                  label="Father Name"
                  placeholder="Enter Father Name"
                  name={`landInfo.owners.[0].fatherOrHusbandName`}
                  type="textInput"
                  maxLength={30}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("Name"),
                      message: "Please enter only letters and spaces",
                    },
                  }}
                  disabled={isEmployee || isApproved || watch("landInfo.owners.[0].fatherOrHusbandName")}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  width={"100%"}
                  control={control}
                  label={t("Gender")}
                  placeholder={t("Gender")}
                  name={`landInfo.owners.[0].gender`}
                  type="searchSelect"
                  data={SortingAlphabatically(genderData)}
                  defaultValue={formData?.landInfo?.owners?.[0]?.gender}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "Please select the gender",
                    },
                  }}
                  disabled={isEmployee || isApproved || watch("landInfo.owners.[0].gender")}
                />
              </Col>
              <Col>
                <InputWrapper
                  width={"100%"}
                  control={control}
                  label="Mobile Number"
                  placeholder="Enter Mobile Number"
                  name={`landInfo.owners.[0].mobileNumber`}
                  type="number"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("MobileNo"),
                      message: "Please enter valid mobile no",
                    },
                  }}
                  disabled={isEmployee || isApproved || watch("landInfo.owners.[0].mobileNumber")}
                  maxLength={10}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  width={"100%"}
                  label="E-mail ID"
                  control={control}
                  placeholder="Enter E-mail ID"
                  name={`landInfo.owners.[0].emailId`}
                  type="textInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("Email"),
                      message: "Please enter valid email id",
                    },
                  }}
                  disabled={isEmployee || isApproved || watch("landInfo.owners.[0].emailId")}
                />
              </Col>
              <Col>
                <InputWrapper
                  width={"100%"}
                  label="Aadhaar Number"
                  control={control}
                  placeholder="Enter Aadhaar Number"
                  name={`landInfo.owners.[0].aadhaarNumber`}
                  type="number"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("AadharNo"),
                      message: "Please enter valid Aadhaar no",
                    },
                  }}
                  disabled={isEmployee || isApproved || watch("landInfo.owners.[0].aadhaarNumber")}
                  maxLength={12}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  width={"100%"}
                  control={control}
                  label="State"
                  placeholder={"Select State"}
                  //defaultValue={owner.correspondenceAddress?.state}
                  name={`landInfo.owners.[0].correspondenceAddress.state`}
                  type="selectInput"
                  disabled={
                    formData?.landInfo?.owners?.[0]?.correspondenceAddress?.state ||
                    isEmployee ||
                    isApproved ||
                    watch("landInfo.owners.[0].correspondenceAddress.state")
                  }
                  data={statesName}
                  mandatory={true}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
              <Col>
                <InputWrapper
                  width={"100%"}
                  control={control}
                  data={watchState === "Uttar Pradesh" ? updistricts : undefined}
                  label={t("LABEL_DISTRICT")}
                  placeholder={watchState === "Uttar Pradesh" ? "Select District" : "Enter District"}
                  name={`landInfo.owners.[0].correspondenceAddress.town`}
                  type={watchState === "Uttar Pradesh" ? "searchSelect" : "textInput"}
                  mandatory
                  maxLength={25}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("Name"),
                      message: "Please enter only letters and spaces",
                    },
                  }}
                  disabled={isEmployee || isApproved || watch("landInfo.owners.[0].correspondenceAddress.town")}
                />
              </Col>
              {/* <Col>
                  <InputWrapper
                    width={"100%"}
                    control={control}
                    label="District"
                    placeholder="Enter District"
                    name={`landInfo.owners[${index}].correspondenceAddress.town`}
                    type="textInput"
                    mandatory
                    maxLength={25}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                      pattern: {
                        value: Digit.Utils.getPattern("Name"),
                        message: "Please enter only letters and spaces",
                      },
                    }}
                    disabled={isEmployee || isApproved}
                  />
                </Col> */}
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  width={"100%"}
                  control={control}
                  label="Communication Address"
                  placeholder="Enter Communication Address"
                  name={`landInfo.owners.[0].correspondenceAddress.address`}
                  type="textInput"
                  mandatory
                  maxLength={150}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("Address"),
                      message: "Please enter valid Address",
                    },
                  }}
                  disabled={isEmployee || isApproved || watch("landInfo.owners.[0].correspondenceAddress.address")}
                />
              </Col>
              <Col>
                <InputWrapper
                  width={"100%"}
                  control={control}
                  label="Pin Code"
                  placeholder="Enter Pin Code"
                  name={`landInfo.owners.[0].correspondenceAddress.pinno`}
                  type="number"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("Pincode"),
                      message: "Please enter valid Pin Code",
                    },
                  }}
                  maxLength={6}
                  disabled={isEmployee || isApproved || watch("landInfo.owners.[0].correspondenceAddress.pinno")}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="custom-upload new-custom-uploader signature-attach-uploader">
                  {!isEmployee && !isApproved && (
                    <FileUploader
                      control={control}
                      name="signature"
                      label="Attach Signature"
                      validationMsg="(jpg, jpeg, png file only and Max file Size 10 MB)"
                      isMandatory
                      required
                      tab={2}
                      maxFiles={1}
                      showError={showError}
                    />
                  )}
                </div>
              </Col>
              <Col></Col>
            </Row>
            <br />
          </Container>

          <div className="footerContainer2">
            <div className="buttonWrapper">
              {!isEmployee && !isApproved && (
                <ButtonWrapper
                  variant="contained"
                  color="success"
                  size="medium"
                  label={"Save"}
                  type="submit"
                  disabled={loading}
                  sx={{ backgroundColor: "black", marginRight: "4px", marginTop: "20px" }}
                />
              )}
            </div>
            <ScrollButton />
          </div>
        </div>
      </form>
    </section>
  );
};

export default SubStep1;
